import { useCallback, useContext } from "react";
import { AppContext } from "@store/context/App";
import { getA3SSettings } from "@helpers/Settings";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useAppSettingsHandler() {
    const { setStage } = useContext(AppContext);

    const getStageValue = useCallback(async (): Promise<void> => {
        // eslint-disable-next-line no-undef
        const a3sSettings = __DEV__ ? await fetch("/a3s-settings.json").then((res) => res.json()) : getA3SSettings();

        setStage(a3sSettings.stage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { getStageValue };
}

export default useAppSettingsHandler;
